import { render, staticRenderFns } from "./TransactionDetailsModal.vue?vue&type=template&id=325960b2&scoped=true"
import script from "./TransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailsModal.vue?vue&type=style&index=0&id=325960b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325960b2",
  null
  
)

export default component.exports